
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/consent/consent-manager",
      function () {
        return require("private-next-pages/events/consent/consent-manager.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/consent/consent-manager"])
      });
    }
  